import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/visit-form-banner`;

export const listVisitFormBanner = async (): Promise<any> => {
  const response = await axios.get(`${API_URL}/list`);
  return response;
};

export const createVisitFormBanner = async (data: any): Promise<any> => {
  const response = await axios.post(`${API_URL}/create`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const updateVisitFormBanner = async (data: any, id: string): Promise<any> => {
  const response = await axios.put(`${API_URL}/update/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const deleteVisitFormBanner = async (id: string, userId: any): Promise<any> => {
  const response = await axios.delete(`${API_URL}/delete/${id}`, {
    data: { userId },
  });
  return response;
};

export const viewVisitFormBanner = async (id: string): Promise<any> => {
    const response = await axios.get(`${API_URL}/view/${id}`);
    return response;
  };


